export const GetValueFromObjectByPath = (obj: Object, pathStr: string, separator: string = '-') => {
  if (!obj) return undefined
  let result: Object = obj
  if (!pathStr) return result
  const path = pathStr.split(separator)
  for (const key of path) {
    const value = (result as any)[key] as Object
    if (!value) {
      return undefined
    }
    result = value
  }
  return result
}
